import React from "react";

import { BrandLogo } from "icons";

import { Button, Typography } from "clearsense-ui/components";

import { NAV_LINKS } from "./constants";

const Navigation = ({ isLoggedIn }) => (
  <div className="flex items-center justify-between w-full h-20 px-20 border-b">
    <div className="flex" data-cy="logo-container">
      <BrandLogo />
      <Typography style="h3" className="flex items-center gap-3 pl-2 font-bold">
        <a className="no-underline focus:outline-none disabled:hover" href="/">
          Clearsense
        </a>
      </Typography>
    </div>
    <div className="flex gap-5">
      {NAV_LINKS.map(item => (
        <div key={item.id} data-cy="nav-links">
          <a href={item.href}>
            <Typography
              style="h4"
              className="flex items-center gap-3 pl-5 font-normal cursor-pointer"
            >
              {item.title}
            </Typography>
          </a>
        </div>
      ))}
      {isLoggedIn && (
        <div key={5}>
          <a href="/pricing">
            <Typography
              style="h4"
              className="flex items-center gap-3 pl-5 font-normal cursor-pointer"
            >
              Pricing
            </Typography>
          </a>
        </div>
      )}
    </div>
    <div className="flex gap-5">
      <Typography
        style="h4"
        className="flex items-center gap-3 pl-5 font-normal"
        data-cy="contact-us-button"
      >
        Contact Us
      </Typography>
      {isLoggedIn ? (
        <Button
          className="text-white bg-gray-900 rounded-full shadow-2xl"
          href="/login"
          label="Dashboard"
          style="secondary"
        />
      ) : (
        <Button
          className="text-white bg-gray-900 rounded-full shadow-2xl"
          href="/api/v1/users/auth/oktaoauth/"
          label="Login"
          style="secondary"
          data-cy="login-button"
        />
      )}
    </div>
  </div>
);

export default Navigation;
